export const recipeCategoryStoreTypes = {
  actions: {
    getRecipeCategories: "GET_RECIPE_CATEGORIES",
    getRecipeCategory: "GET_RECIPE_CATEGORY",
  },
};
